import { Global, MiddlewareConsumer, Module } from '@nestjs/common';
import { ScheduleModule } from '@nestjs/schedule';
import { DatacollectorModule } from '../datacollector/datacollector.module';

import { CoreController } from './core.controller';
import { CoreService } from './core.service';
import { SnmpService } from './services/snmp.service';
import { OltDB } from './services/olt_database.service';
import { OidDB } from './services/oid.service';
import { HuaweiOidDB } from './services/huawei_oid.service';
import { OltService } from './services/olt.service';
import { PortService } from './services/port.service';
import { GponService } from './services/gpon.service';
import { ServicePortService } from './services/serviceport.service';
import { ContextMiddleware, ServerAuthModule } from '@ip6m/server/auth';
import { ServerFeatureConfigurationModule } from '@ip6m/server/feature-configuration';
import { DatabaseModule } from '../database/database.module';
import { CustomerApiModule } from '../customer-api/customer-api.module';
import { PublicUserService } from './services/user.service';
import { ServerDataAccessUserModule } from '@ip6m/server/data-access-user';

@Global()
@Module({
  imports: [
    ScheduleModule.forRoot(),
    ServerAuthModule,
    ServerDataAccessUserModule,
    ServerFeatureConfigurationModule,
    DatabaseModule,
    CustomerApiModule,
    DatacollectorModule
  ],
  exports: [
    OltDB,
    GponService,
    HuaweiOidDB,
    SnmpService
  ],
  controllers: [CoreController],
  providers: [
    CoreService,
    PublicUserService,
    SnmpService,
    OltService,
    OltDB,
    OidDB,
    HuaweiOidDB,
    PortService,
    GponService,
    ServicePortService]
})
export class CoreModule {
  configure(consumer: MiddlewareConsumer): void {
    consumer.apply(ContextMiddleware).forRoutes(CoreController);
  }
}
